import { POST_OUR_WORK_START } from '../../types';

export const post_our_work = (payload) => ({
  type: POST_OUR_WORK_START,
  payload,
});
